import VacationsAllowencesHistory from './VacationsAllowencesHistory';

export default VacationsAllowencesHistory;
